var layout_default = {
  "layout": "TbuiR",
  "cell": "yFKff"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
